import kitchenInstance from '../instance'

const updateKitchenConfig = (id, data) => {
	return kitchenInstance.put(`/kitchenConfigs/${id}`, data)
}

export default updateKitchenConfig